var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTax(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "#FFF",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    viewBox: "0 0 490.1 490.1",
    xmlSpace: "preserve",
    "data-locator-target": "vscode",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none"
    },
    x1: 20.95,
    y1: 469.1,
    x2: 20.95,
    y2: 79.2
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none"
    },
    x1: 132.45,
    y1: 469.1,
    x2: 132.45,
    y2: 188.7
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none"
    },
    x1: 245.05,
    y1: 469.1,
    x2: 245.05,
    y2: 262.7
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none"
    },
    x1: 357.65,
    y1: 469.1,
    x2: 357.65,
    y2: 339.9
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none"
    },
    x1: 469.15,
    y1: 469.1,
    x2: 469.15,
    y2: 414.9
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.95,58.4c-11.5,0-20.9,9.4-20.9,20.8v389.9c0,11.5,9.4,20.9,20.9,20.9c10.4,0,19.8-9.4,20.9-20.9V79.2    C41.75,67.8,32.35,58.4,20.95,58.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.45,167.9c-11.5,0-20.9,9.4-20.9,20.9v280.4c0,11.5,9.4,20.9,20.9,20.9s20.9-9.4,20.9-20.9V188.7    C153.35,177.2,143.95,167.9,132.45,167.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.05,241.9c-11.5,0-20.9,9.4-20.9,20.9v206.4c0,11.5,9.4,20.9,20.9,20.9c11.5,0,20.9-9.4,20.9-20.9V262.7    C265.95,251.3,256.55,241.9,245.05,241.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.65,319c-11.5,0-20.9,9.4-20.9,20.9v129.3c0,11.5,9.4,20.9,20.9,20.9s19.8-9.4,20.9-20.9V339.9    C378.45,328.4,369.15,319,357.65,319z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.15,394.1c-11.5,0-20.9,9.4-20.9,20.9v54.2c0,11.5,9.4,20.9,20.9,20.9s20.9-9.4,20.9-20.9V415    C490.05,403.5,480.65,394.1,469.15,394.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.55,254.4l-34.3-14.6c-10.4-5.2-22.9,0-27.1,10.4c-5.2,10.4,0,22.9,10.4,27.1l97,41.7c12.2,5.9,24.6-0.7,28.1-17.7    l10.4-105.3c1-10.4-7.3-20.9-18.8-21.9c-10.4-1-20.9,7.3-21.9,18.8l-4.5,47.2C292.35,10.7,67.45,0,57.35,0c-1,0-1,0-1,0    c-11.5,0-20.9,8.3-20.9,19.8s8.3,20.9,19.8,20.9C57.25,40.7,264.25,51.2,404.55,254.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTax);
export default __webpack_public_path__ + "static/media/tax.3f148051bfc0119d1812a84a21b3c8b8.svg";
export { ForwardRef as ReactComponent };